import {Component, OnInit} from '@angular/core';
import {environment} from '~/environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {AdService} from '@services/ad.service';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '@services/authentification.service';
import {PubOpenComponent} from '@module/search/popup/pub-open/pub-open.component';
import {MatDialog} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
import {AlertService} from '@services/alert.service';

@Component({
    selector: 'app-open-ad',
    templateUrl: './open-ad.component.html',
    styleUrls: ['./open-ad.component.scss']
})
export class OpenAdComponent implements OnInit {

    params;
    stripe = Stripe(environment.stripeKey);

    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        public dialog: MatDialog,
        private router: Router,
        private adService: AdService,
        private alertService: AlertService,
        public trackingService: TrackingService,
        public authenticationService: AuthenticationService,
    ) {
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.params = params;

            this.adService.openAd(params.id).subscribe(favorite => {
                favorite.notary_price = null; // To calc them
                favorite = this.adService.fillUSerInfo(favorite);
                favorite = this.adService.updateValues(favorite);
                favorite.pictures_string = favorite.pictures.join(';');
                this.http.put(environment.apiUrl + 'app/favorite/' + favorite.id, favorite).subscribe(result => {

                    if (!this.adService.isAdVisible(favorite, -1)) {
                        if (this.authenticationService.isLogin) {
                            this.trackingService.click("mail_open_ad_plan_open", favorite.ad.ai_id);
                            const dialogRef = this.dialog.open(PubOpenComponent, {
                                width: '700px',
                                disableClose: true,
                                data: {
                                    close: false,
                                },
                            });

                            dialogRef.afterClosed().subscribe(result => {
                                if (result !== null && result !== undefined && result !== '') {
                                    this.trackingService.click("mail_open_ad_plan_confirm", favorite.ad.ai_id);
                                    this.http.post<any>(`${environment.apiUrl}app/paiement/create-checkout-session`,
                                        {plan: result, duration: 'month'}).subscribe(
                                        session => {
                                            this.trackingService.checkout({value: result});
                                            this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                                                if (result.error) {
                                                    // alert(result.error.message);
                                                }
                                            });
                                        },
                                        (error) => {
                                            console.log(error);
                                        });
                                }
                            });
                        } else {
                            this.router.navigate(['/app/login']);
                        }
                    } else {
                        this.router.navigate(['/app/annonces', favorite.id, 'annonce'], {queryParams: {returnUrl: this.router.url}});
                    }
                }, error => {
                    if (error != 'token_outdate') {
                        this.alertService.error('Une erreur est survenue lors de l\'enregistrement.');
                    }
                });
            }, error => {
                if (error != 'token_outdate') {
                    this.alertService.error('Annonce introuvable', true);
                    this.router.navigate(['/app/favorites', params.id]);
                }
            });
        });

        // this.http.post<Favorite>(environment.apiUrl + 'app/favorite', fav);
    }

}
